import type { EditSchemaDefinition } from "@/shared/components/CRUD/types";
import { CRUD } from "@/shared/components";
import {
  SupportRequestsListQuery,
  SupportRequestShowQuery,
} from "@/admin/entities/assistant";
import { skipHiddenPagePoll } from "@/shared/utils/skipHiddenPagePoll";
import { SupportRequestDetails } from "./SupportRequestDetails";
import { REQUEST_CARD_POLL_MS } from "../model/thread";
import {
  useSupportRequestsManagement,
  type SupportRequestRow,
  SupportRequestsSchemas,
} from "../model";

const editSchema: EditSchemaDefinition = {
  details: {
    // Раздел, шаг и заголовок CrudShow называются одинаково и схлопываются
    // в одну крошку «Обращение»; номер и тема в шапке самой карточки.
    label: "Обращение",
    type: "show" as const,
    showComponent: SupportRequestDetails,
    showQuery: SupportRequestShowQuery,
    // Пока карточка открыта: новый ответ зрителя письмом. В скрытой вкладке
    // тик пропускается, закрытый диалог размонтирует запрос и не опрашивает.
    showPollInterval: REQUEST_CARD_POLL_MS,
    showSkipPollAttempt: skipHiddenPagePoll,
  },
};

/**
 * Реестр обращений зрителей в поддержку, созданных через помощника.
 * Создания и удаления нет, ответ и статус в карточке.
 */
export function SupportRequests() {
  const { columns, mobileColumns, mapColumns, getTableData, texts } =
    useSupportRequestsManagement();

  return (
    <CRUD<SupportRequestRow>
      listQuery={SupportRequestsListQuery}
      getTableData={getTableData}
      mapColumns={mapColumns}
      columns={columns}
      filterSchema={SupportRequestsSchemas.filterSchema}
      editSchema={editSchema}
      texts={texts}
      persistFilters
      hideCreateButton
      useMobileView
      mobileColumns={mobileColumns}
    />
  );
}
